import $ from 'sbf-design-system/js/jquery';
import banner from 'sbf-design-system-component/banners/banner';
import Overlay from 'sbf-design-system-component/overlays/overlay';

const signInOverlay = new Overlay($('#signInOverlay'), {
  full_screen: true
});

const forgotCredOverlay = new Overlay($('#forgotOverlay'), {
  full_screen: true
});

$('#signin-overlay-trigger, #signin-overlay-trigger-mobile').on('click', () => {
  signInOverlay.show();
});

const closeSignInOverlay = () => {
  signInOverlay.hide();
  forgotCredOverlay.hide();
  resetOverlay();
  banner.close();
};

$('.cancel').on('click', closeSignInOverlay);

$('.overlay__close').on('click', () => {
  resetOverlay();
});

// Choosing SBF login opens the next step
$('.sbf-sign-in').on('click', () => {
  $('#step1').addClass('hidden');
  $('#step2').removeClass('hidden');
});

// Sync username fields
$('.username').change(e => {
  $('.username').val(e.target.value);
  $('.username').keyup();
});

$('.fb-sign-in').on('click', (e) => {
  e.preventDefault();
  banner.showLoading('Signing in, please wait...', false, false);
  triggerFacebookLogin();
});

// ensure the page doesn't break if the facebook SDK doesn't load
if (typeof (window.FB) === 'object') {
  window.FB.init({
    appId: window.gon.fb_app_id,
    cookie: true,
    status: false,
    version: 'v19.0'
  });
}

$('#forgotUserOverlayTrigger').on('click', (e) => {
  e.preventDefault();
  $('.forgot-password-step').addClass('hidden');
  signInOverlay.hide();
  $('.forgot-username-step').removeClass('hidden');
  forgotCredOverlay.show();
});

$('#forgotPassOverlayTrigger').on('click', (e) => {
  e.preventDefault();
  $('.forgot-username-step').addClass('hidden');
  signInOverlay.hide();
  $('.forgot-password-step').removeClass('hidden');
  $('#forgotOverlay').find('.overlay__heading h1').html('Forgot your password?');
  forgotCredOverlay.show();
});

$('#forgotUserSubmit').on('click', (e) => {
  e.preventDefault();
  banner.showLoading('Please wait...');
  processForgotUsername($('#email_address').val(), forgotUsernameSuccess, forgotUsernameSuccess);
});

$('#forgotPassSubmit').on('click', (e) => {
  e.preventDefault();
  banner.showLoading('Please wait...');
  processForgotPassword($('#username').val(), forgotPasswordSuccess, forgotPasswordSuccess);
});

$('#logoutLink').on('click', (e) => {
  e.preventDefault();
  processSignOut(locationReload, signOutFail);
});

const resetOverlay = () => {
  // Resets the signInOverlay's elements
  $('#step2').addClass('hidden');
  $('#step1').removeClass('hidden');
  $('.forgot-password-step').addClass('hidden');
  $('.forgot-username-step').removeClass('hidden');
};

const triggerFacebookLogin = () => {
  window.FB.login((response) => {
    if (response.status === 'connected') {
      processFacebookLogin(response.authResponse);
    } else if (response.status === 'not_authorized') {
      facebookUserNotFound();
    } else {
      closeSignInOverlay();
    }
  }, { scope: 'public_profile,email' });
};

const processFacebookLogin = (r) => {
  $.ajax({
    url: '/ajax/socialconnect/fblogin',
    type: 'post',
    dataType: 'json',
    data: {
      token: r.accessToken,
      identifier: r.userID
    },
    success: (response) => {
      if (response.data && response.data.success) {
        // Successfully logged in reload page
        locationReload();
      } else if (response.error && response.error.code === 1103) {
        // User hasn’t connected Facebook before
        facebookUserNotFound();
      } else {
        facebookLoginRejected();
      }
    },
    error: (jq, textStatus, errorThrown) => {
      facebookLoginFail();
    }
  });
};

const locationReload = () => {
  // get the URL of the page minus the querystring
  const url = window.location.toString().replace('#', '');
  window.location = url;
};

$('#submitLogin').on('click', (click) => {
  click.preventDefault();
  banner.showLoading('Signing in, please wait...', false, false);
  processSignIn($('#username').val(), $('#user_password').val(), locationReload, signInFail);
});

const facebookUserNotFound = () => {
  banner.showError('Your Facebook account is not currently connected with the St.&nbsp;Baldrick&rsquo;s&nbsp;Foundation. Please donate without logging in.');
};

const facebookLoginRejected = () => {
  facebookLoginFail();
};

const facebookLoginFail = () => {
  banner.showMessage('Sorry, we had an issue connecting you to Facebook. Please try again.');
};

const forgotUsernameSuccess = () => {
  banner.showMessage('If an account exists for the email address you provided, the username has been sent to that address. If you need further assistance, please contact St.&nbsp;Baldrick&rsquo;s at sbinfo@stbaldricks.org or call us at (888)&nbsp;899&#8209;2253.');
};

const forgotPasswordSuccess = () => {
  banner.showMessage('If an account exists for the username you provided, a password reset link has been sent to the email address associated with that account. If you need further assistance, please contact St. Baldrick&rsquo;s at sbinfo@stbaldricks.org or call us at (888)&nbsp;899&#8209;2253.');
};

const processSignIn = (username, password, success, fail) => {
  const url = `https://${window.location.host}/ajax/sbflogin/login`;

  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: { username, password },
    success: (response) => {
      if (response.data && response.data.success) {
        success(response);
      } else {
        fail(response);
      }
    },

    error: (xhr, status, err) => {
      fail(xhr, status, err);
    }
  });
};

const processSignOut = (success, fail) => {
  const url = `https://${window.location.host}/ajax/sbflogin/logout`;

  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: {},
    success: (response) => {
      if (response.data && response.data.success) {
        success(response);
      } else {
        fail(response);
      }
    },

    error: (xhr, status, err) => {
      fail(xhr, status, err);
    }
  });
};

const processForgotUsername = (email, success, fail) => {
  const url = `https://${window.location.host}/ajax/sbflogin/forgotusername`;

  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: { emailAddress: email },
    success: (response) => {
      if (response.data && response.data.success) {
        success(response);
      } else {
        fail(response);
      }
    },

    error: (xhr, status, err) => {
      fail(xhr, status, err);
    }
  });
};

const processForgotPassword = (username, success, fail) => {
  const url = `https://${window.location.host}/ajax/sbflogin/forgotpassword`;

  $.ajax({
    url,
    type: 'post',
    dataType: 'json',
    data: { username },
    success: (response) => {
      if (response.data && response.data.success) {
        success(response);
      } else {
        fail(response);
      }
    },

    error: (xhr, status, err) => {
      fail(xhr, status, err);
    }
  });
};

const signInFail = (err) => {
  let errorMessage;
  if (err.error.code === 1103) {
    errorMessage = 'Your username and password combination was invalid. Please try again.';
  } else if (err.error.code === 1107) {
    errorMessage = 'Your password does not meet our security standards. A password reset link has been sent to the email address you\'ve provided.';
  } else {
    errorMessage = 'Invalid username or password. Please try again.';
  }
  banner.showError(errorMessage, true, 2000);
};

const signOutFail = () => {
  banner.showError('Sorry, an error has occurred. Please reload the page.', true, false);
};
